import {HgPricingCard} from '~/design-system/hg/components'
import HgPricingCardsHeading from './components/HgPricingCardsHeading'
import {type HgPricingCardsProps} from './types'

export type HgPricingCardsViewProps = HgPricingCardsProps & {
  checked: boolean
  onCheckedChange?: (checked: boolean) => void
}

export default function HgPricingCardsStateless({
  pricingCards,
  headingEyebrow,
  headingToggleLabel,
  checked,
  onCheckedChange,
}: HgPricingCardsViewProps) {
  return (
    <>
      <div className="w-full border-b border-border-frosted py-s3">
        <HgPricingCardsHeading
          headingEyebrow={headingEyebrow}
          headingToggleLabel={headingToggleLabel}
          checked={checked}
          onCheckedChange={onCheckedChange}
        />
      </div>
      <div className="grid w-full grid-rows-[repeat(3,minmax(0,auto))] md:grid-flow-col md:grid-cols-3 md:gap-y-s5">
        {pricingCards.map(pricingCard => (
          <HgPricingCard
            key={pricingCard.id}
            {...pricingCard}
            isMonthly={!checked}
            className="row-span-3 grid gap-y-s5 border-border-frosted p-s5 md:grid-rows-subgrid max-md:[&:not(:last-child)]:border-b md:[&:not(:last-child)]:border-r"
          />
        ))}
      </div>
    </>
  )
}
